import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './responsive.css';
import RootRouter from './RootRouter';
import './assets/css/argon-dashboard-react.css';
import * as serviceWorker from './serviceWorker';
import { registerServiceWorker } from './firebasesw';


ReactDOM.render(<RootRouter />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
registerServiceWorker();
serviceWorker.register();
